import { getPath } from '@/router/common'

const baseUrl = {
  title: '回单总账',
  path: 'ReportTpl'
}

export default [
  {
    path: getPath('Index', baseUrl),
    name: 'ReportTpl_Index',
    component: () => import(/* webpackChunkName: "ReportTpl_Index" */ '@/views/reportTpl/index/index.vue'),
    meta: {
      title: '前台收银日报表'
    }
  },
  {
    path: getPath('GetDataCommon_GridDPM', baseUrl),
    name: 'ReportTpl_GetDataCommon_GridDPM',
    component: () => import(/* webpackChunkName: "ReportTpl_GetDataCommon_GridDPM" */ '@/views/reportTpl/getDataCommon_GridDPM/index.vue'),
    meta: {
      title: '回单总账记录(多品名)'
    }
  },
  {
    path: getPath('ReportTpl_CashierDetail', baseUrl),
    name: 'ReportTpl_ReportTpl_CashierDetail',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportTpl_CashierDetail" */ '@/views/reportTpl/reportTpl_CashierDetail/index.vue'),
    meta: {
      title: '出纳余额明细表'
    }
  },
  {
    path: getPath('ReportTpl_YewuyuanDetail', baseUrl),
    name: 'ReportTpl_ReportTpl_YewuyuanDetail',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportTpl_YewuyuanDetail" */ '@/views/reportTpl/reportTpl_YewuyuanDetail/index.vue'),
    meta: {
      title: '对账明细表'
    }
  },
  {
    path: getPath('ReportTpl_turnoverDetail', baseUrl),
    name: 'ReportTpl_ReportTpl_turnoverDetail',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportTpl_turnoverDetail" */ '@/views/reportTpl/reportTpl_turnoverDetail/index.vue'),
    meta: {
      title: '营业额明细'
    }
  },
  {
    path: getPath('SiteAccount', baseUrl),
    name: 'ReportTpl_SiteAccount',
    component: () => import(/* webpackChunkName: "ReportTpl_SiteAccount" */ '@/views/reportTpl/siteAccount/index.vue'),
    meta: {
      title: '网点收支财务统计表'
    }
  },
  {
    path: getPath('YSFQuery', baseUrl),
    name: 'ReportTpl_YSFQuery',
    component: () => import(/* webpackChunkName: "ReportTpl_YSFQuery" */ '@/views/reportTpl/ySFQuery/index.vue'),
    meta: {
      title: '预收付款查询'
    }
  },
  {
    path: getPath('ReportAnalyze', baseUrl),
    name: 'ReportTpl_ReportAnalyze',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportAnalyze" */ '@/views/reportTpl/reportAnalyze/index.vue'),
    meta: {
      title: '货量排名分析表'
    }
  },
  {
    path: getPath('ReportAnalyzeDetail', baseUrl),
    name: 'ReportTpl_ReportAnalyzeDetail',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportAnalyzeDetail" */ '@/views/reportTpl/reportAnalyzedetail/index.vue'),
    meta: {
      title: '货量排名分析表明细'
    }
  },
  {
    path: getPath('SiteAccountDetail', baseUrl),
    name: 'ReportTpl_SiteAccountDetail',
    component: () => import(/* webpackChunkName: "ReportTpl_SiteAccountDetail" */ '@/views/reportTpl/siteAccountDetail/index.vue'),
    meta: {
      title: '查看详情'
    }
  },
  {
    path: getPath('ReportTpl_turnoverMain', baseUrl),
    name: 'ReportTpl_ReportTpl_turnoverMain',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportTpl_turnoverMain" */ '@/views/reportTpl/reportTpl_turnoverMain/index.vue'),
    meta: {
      title: '营业额汇总表'
    }
  },
  {
    path: getPath('branchProfit', baseUrl),
    name: 'Branch_Profit_Index',
    component: () => import(/* webpackChunkName: "ReportTpl_ReportTpl_turnoverMain" */ '@/views/reportTpl/branchProfit/index.vue'),
    meta: {
      title: '网点利润表'
    }
  } ,
  {
    path: getPath('ReportIntegral', baseUrl),
    name: 'ReportTpl_Integral',
    component: () => import(/* webpackChunkName: "ReportTpl_Intergral" */ '@/views/reportTpl/reportIntegral/index.vue'),
    meta: {
      title: '积分报表'
    }
  },
  {
    path: getPath('ReportAlarmPush', baseUrl),
    name: 'ReportTpl_AlarmPush',
    component: () => import(/* webpackChunkName: "ReportTpl_AlarmPush" */ '@/views/reportTpl/reportAlarmPush/index.vue'),
    meta: {
      title: '预警推送报表'
    }
  },
  {
    path: getPath('Shipment', baseUrl),
    name: 'ReportTpl_Shipment',
    component: () => import(/* webpackChunkName: "ReportTpl_Shipment" */ '@/views/reportTpl/shipment/index.vue'),
    meta: {
      title: '发货按月汇总表'
    }
  },
]
